import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useParams} from 'react-router-dom'
import ProductDetails from './ProductDetails'
import Summary from './Summary'
import RecentEvents from './RecentEvents'
import Invoices from './Invoices'
import './index.css'

function BillingsPage() {
  const {id} = useParams()
  const Onboardings = [
    {
      title: `(${id})`,
      path: `/${id}/subscriptions`,
      isSeparator: false,
      isActive: false,
    },
  ]

  return (
    <>
      <PageTitle breadcrumbs={Onboardings}>Subscriptions</PageTitle>

      <div className='d-flex flex-column flex-md-row' style={{height: '100vh'}}>
        <div
          className='product-container me-md-5 h-100 overflow-auto order-2 order-md-1'
          style={{maxHeight: '100%', minHeight: '100%'}}
        >
          <ProductDetails />
          <RecentEvents />
          <Invoices />
        </div>
        <div className='summary-container ms-md-5 order-1 mb-5 mb-md-0 order-md-2'>
          <Summary />
        </div>
      </div>
    </>
  )
}

export default BillingsPage
